import React from "react";
import "./count.css";

const Count = () => {
  return (
    <div>
      <div
        className="count__row-container"
        style={{ display: "flex", height: "100%" }}
      >
        <div className="count_details">
          <h1>342</h1>
          <h3>Cups of coffee</h3>
        </div>
        <div className="count_details">
          <h1>756</h1>
          <h3>Bicycle kilometres</h3>
        </div>
        <div className="count_details">
          <h1>419</h1>
          <h3>Brainstorm session</h3>
        </div>
        <div className="count_details">
          <h1>284</h1>
          <h3>Video hours</h3>
        </div>
      </div>
    </div>
  );
};

export default Count;
